import Axios from "axios";
import User from "./User";
import store from "../src/store";

/**
 * @typedef PropertyDefinition
 * @property {number} id
 * @property {boolean} commercial
 * @property {boolean} deleted
 * @property {string} name
 * @property {number} organization
 * @property {string} phoneNumber
 * @property {AddressDefinition} address
 * @property {string} email
 * @property {PaymentDefinition} payments
 */

/**
 * @typedef PaymentDefinition
 * @property {boolean} isLiveMode
 * @property {string} pk
 * @property {string} processor
 */

/**
 * @typedef AddressDefinition
 * @property {string} full
 * @property {string} zip
 * @property {string} city
 * @property {string} state
 * @property {string} streetNumber
 * @property {string} streetName
 */

class PropertyClass {

  constructor() {
    this.commercial = false;
    this.payments = {};
    this.address = {};
    this.files = [];
  }

  async init() {
    if (store.state.organization && User.token) {
      let property = await Axios.get(CONFIG.urlServer + "/api/properties/" + store.state.property, {
        headers: {
          "Authorization": "Bearer " + User.token
        }
      });
      this.load(property.data);
    }
  }

  async loadFiles() {
    this.files = [];
    if (store.state.organization && User.token) {
      let result = await Axios.get(`${CONFIG.urlServer}/api/files?organization=${store.state.organization}&perPage=-1`, {
        headers: {
          "Authorization": "Bearer " + User.token
        }
      });
      if (result) {
        this.files = result.data.data;
      }
    }
  }

  /**
   * @param {PropertyDefinition} definition
   */
  load(definition) {
    this.commercial = definition.commercial;
    this.payments = definition.payments;
    this.address = definition.address;
    this.files = [];
  }

  hasPaymentEnabled() {
    return !!this.payments;
  }

  hasStripeEnabled() {
    return this.payments && this.payments.processor === "stripe";
  }

  hasPaysafeEnabled() {
    return this.payments && this.payments.processor === "paysafe";
  }

  getPaymentPublicKey() {
    if (!this.hasPaymentEnabled()) {
      return;
    }
    return this.payments.pk;
  }

}

let Property = new PropertyClass();
export default Property;
